import { commonUtil } from '@/util'

const request = {}

request.createRequest = function (jdProductData) {
  const jdproductRelatedProductList =
    jdProductData.jdproductRelatedProductList.map((ele) => {
      return {
        productId: ele.productId,
        quantity: ele.quantity,
        price: ele.price
      }
    })

  return {
    exProductNumber: jdProductData.jdProductInfoLine1.jdproductNumber,
    platformId: jdProductData.jdProductInfoLine1.platform.value,
    sku: jdProductData.jdProductInfoLine1.sku
      ? jdProductData.jdProductInfoLine1.sku
      : null,
    name: jdProductData.jdProductInfoLine2.name,
    invisibleFlg: jdProductData.jdProductInfoLine2.invisibleFlg,
    exProductRelatedProductList: jdproductRelatedProductList
  }
}
export default { request }
